import type { ReactNode } from 'react'
import { Alert, Result, Spin } from 'antd'
import { LockOutlined } from '@ant-design/icons'
import { useAgentBuilderAccess } from '../hooks'

const AGENT_BUILDER_ACCESS_DENIED_TITLE = "PracIntel isn't available yet"
const AGENT_BUILDER_ACCESS_DENIED_MESSAGE =
  'To access this feature, your practice must have a valid platform connected and you must be a member of a user group for that platform type. Please contact your administrator.'

export function AgentBuilderAccessDenied() {
  return (
    <div className="flex min-h-[40vh] w-full items-center justify-center">
      <div className="w-full max-w-3xl rounded-2xl border border-brand-100 bg-gradient-to-br from-white to-sky-50/40 shadow-card">
        <Result
          icon={<LockOutlined className="!text-brand-500" />}
          title={AGENT_BUILDER_ACCESS_DENIED_TITLE}
          subTitle={<span className="mx-auto block max-w-xl">{AGENT_BUILDER_ACCESS_DENIED_MESSAGE}</span>}
        />
      </div>
    </div>
  )
}

export default function AgentBuilderAccessGate({ clientId, children }: { clientId: string; children: ReactNode }) {
  const access = useAgentBuilderAccess(clientId)

  if (!clientId) return <>{children}</>

  if (access.isLoading) {
    return (
      <div className="flex justify-center py-12">
        <Spin />
      </div>
    )
  }

  if (access.isError) {
    return (
      <Alert
        type="error"
        showIcon
        className="m-6"
        message="Failed to check PracIntel access"
        description={access.error instanceof Error ? access.error.message : 'Unknown error'}
      />
    )
  }

  return access.canAccess ? <>{children}</> : <AgentBuilderAccessDenied />
}
